@if (repo.resource$ | async; as data) {
  <div>
    <!-- Queues monitoring table -->
    @if (data.length > 0) {
      <table mat-table matSort (matSortChange)="sort($event)" [dataSource]="data" multiTemplateDataRows>
        <ng-container matColumnDef="icon">
          <th mat-header-cell *matHeaderCellDef> </th>
          <td mat-cell *matCellDef="let monitor">
            <mat-icon [class]="getIconClass(monitor)">{{ getIcon(monitor) }}</mat-icon>
          </td>
        </ng-container>
        <ng-container matColumnDef="automationName">
          <th mat-header-cell mat-sort-header *matHeaderCellDef id="automationName"> {{ 'queueMonitors.processName' | transloco }} </th>
          <td mat-cell *matCellDef="let monitor"> {{ monitor.automationName }} </td>
        </ng-container>
        <ng-container matColumnDef="isAutomationEnabled">
          <th mat-header-cell mat-sort-header *matHeaderCellDef id="isAutomationEnabled"> {{ 'queueMonitors.enabled' | transloco }} </th>
          <td mat-cell *matCellDef="let monitor">
            <mat-checkbox [(ngModel)]="monitor.isAutomationEnabled" class="checkbox" (change)="onUpdateAutomationMonitor(monitor)"></mat-checkbox>
          </td>
        </ng-container>
        <ng-container matColumnDef="currentQueueSize">
          <th mat-header-cell mat-sort-header *matHeaderCellDef id="currentQueueSize"> {{ 'queueMonitors.ordersInQueue' | transloco }} </th>
          <td mat-cell *matCellDef="let monitor"> {{ monitor.currentQueueSize }} </td>
        </ng-container>
        <ng-container matColumnDef="maxQueueSize">
          <th mat-header-cell mat-sort-header *matHeaderCellDef id="maxQueueSize"> {{ 'queueMonitors.maxSize' | transloco }} </th>
          <td mat-cell *matCellDef="let monitor"> {{ monitor.maxQueueSize }} </td>
        </ng-container>
        <ng-container matColumnDef="lastSuccessfulRunDate">
          <th mat-header-cell mat-sort-header *matHeaderCellDef id="lastSuccessfulRunDate"> {{ 'queueMonitors.lastSuccessfulRun' | transloco }} </th>
          <td mat-cell *matCellDef="let monitor"> {{ monitor.lastSuccessfulRunDate | localizedDate }} </td>
        </ng-container>
        <ng-container matColumnDef="delete">
          <th mat-header-cell *matHeaderCellDef [attr.aria-label]="'common.labels.rowActions' | transloco">&nbsp;</th>
          <td mat-cell *matCellDef="let monitor">
            <button mat-icon-button color="accent" (click)="onDeleteMonitor(monitor)" [attr.aria-label]="'queueMonitors.deleteMonitor' | transloco">
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    }
    <!-- End of queues monitoring table -->
    <div class="spacer-small"></div>
    @if (data.length > 0) {
      <mat-paginator [pageSize]="this.repo.pageSize$ | async"
        [length]="this.repo.resourceCount$ | async" [pageIndex]="this.repo.pageNum$ | async"
        [pageSizeOptions]="[5, 10, 25]" [showFirstLastButtons]="((this.repo.totalPages$ | async) ?? 1) > 2"
      (page)="page($event)"></mat-paginator>
    }
  </div>
}